var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-card',{attrs:{"title":"Histórico de Faturamento","filter-button":"","periodFilter":false,"data":_vm.chartData,"loader":"faturamento","is-currency":""}})}
var staticRenderFns = []

export { render, staticRenderFns }